import { useCallback } from 'react';
import { useCompassCard } from '@scale/compass-ui/store';
import {
  type SweapPassAtKContext,
  SweapRunMode,
} from '@scale/genai-compass-shared/cards/sweap_pass_at_k';
import type { ChatApiEndpointWithId } from '@scale/shared/types/chat';

export default function useSweapPassAtKCard(index: number) {
  const { card, updateCardContext } = useCompassCard<SweapPassAtKContext>(index);
  const context = card.defaultContext;

  const setRunMode = useCallback(
    (runMode: SweapRunMode) => {
      updateCardContext({ ...context, runMode });
    },
    [context, updateCardContext],
  );

  const setK = useCallback(
    (k: number) => {
      updateCardContext({ ...context, k });
    },
    [context, updateCardContext],
  );

  const setConfigS3Uri = useCallback(
    (configS3Uri: string) => {
      updateCardContext({ ...context, configS3Uri });
    },
    [context, updateCardContext],
  );

  const setModelConfig = useCallback(
    (modelConfig: ChatApiEndpointWithId | undefined) => {
      updateCardContext({ ...context, modelConfig } as SweapPassAtKContext);
    },
    [context, updateCardContext],
  );

  const setBatchId = useCallback(
    (batchId: string) => {
      updateCardContext({ ...context, batchId });
    },
    [context, updateCardContext],
  );

  return {
    context,
    setRunMode,
    setK,
    setConfigS3Uri,
    setModelConfig,
    setBatchId,
  };
}
